type AppEnv = {
  appName: string;
  appEnv: string;
  supabaseUrl?: string;
  supabasePublishableKey?: string;
  publicAppUrl?: string;
};

export const env: AppEnv = {
  appName: import.meta.env.VITE_APP_NAME || 'BelajarKu',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || undefined,
  supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || undefined,
  publicAppUrl: import.meta.env.VITE_PUBLIC_APP_URL || undefined,
};
